import { memo, useCallback, type ChangeEvent } from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import type { FormFieldBaseProps } from './field-base';

export interface TextAreaFieldProps extends FormFieldBaseProps<string | null | undefined> {}

export const TextAreaField = memo(function TextAreaField({
  field,
  value,
  onChange,
  readOnly = false,
  error,
}: TextAreaFieldProps) {
  const { theme } = useTheme();

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) => {
      onChange(e.target.value);
    },
    [onChange],
  );

  const errorId = error ? `${field.key}__error` : undefined;
  return (
    <div className={'form-group textarea-field' + (theme ? ' ' + theme : '') + (error ? ' has-error' : '')}>
      <label className={'field-label' + (field.required ? ' required' : '')} htmlFor={field.key}>
        {field.label}
      </label>
      <textarea
        id={field.key}
        name={field.key}
        className={'kstc-input form-textarea' + (error ? ' form-input--error' : '')}
        value={value ?? ''}
        onChange={handleChange}
        disabled={readOnly}
        required={field.required === true}
        title={error || undefined}
        aria-invalid={error ? true : undefined}
        aria-describedby={errorId}
      />
      {error ? <div id={errorId} className="form-field-error" role="alert">{error}</div> : null}
    </div>
  );
});
